import React, {useState} from 'react';
import './EnvioMensajes.css';
import api from '../../../services/api';
import swal from 'sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faClipboard } from '@fortawesome/free-solid-svg-icons'
import studentImage from '../../../images/student_portrait.svg'

const EnvioMensajes = () => {
    const [mensaje, setMensaje] = useState('');
    const [showMessage, setShowMessage] = useState(false);

    const [showInfo, setShowInfo] = useState(false);
    const [infoAlumno, setInfoAlumno] = useState([]);
    const [fotoAlumno, setFotoAlumno] = useState();

    const [showSearch, setShowSearch] = useState(false);
    const [listaAlumnos, setListaAlumnos] = useState([]);
    const [alumno, setAlumno] = useState([]);
    
    const [alumnos, setAlumnos] = useState([]);
    const [alumnosSeleccionados, setAlumnosSeleccionados] = useState([]);
    const [nivel, setNivel] = useState(1);
    const [grado, setGrado] = useState(1);
    const [grupo, setGrupo] = useState(null);

    const buttonDisable = {
        cursor: "not-allowed",
        opacity: "0.5",
        pointerEvents: "none",
    }

    const buscar1Alumno = async () => {
        setShowSearch(true);    
        try {
            const response = await api.getAlumnosAsistencias({alumno});
            setListaAlumnos(response.data.data);
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    const buscarAlumnos = async () => {
        try {
            const response = await api.getAlumnosList({nivel, grado, grupo});
            setAlumnos(response.data.data);
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }
    }

    async function verInfoAlumno(alumno) {
        try {
            setShowInfo(true);
            setInfoAlumno(alumno);
            
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }

        try {
            const MATRICULA = alumno.MATRICULA;
            const response = await api.getFotoAlumno({MATRICULA});
            const FOTO = response.data.data.FOTO;

            const arrayBuffer = new Uint8Array(FOTO.data);
            const base64String = btoa(
              arrayBuffer.reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            setFotoAlumno(`data:image/jpeg;base64,${base64String}`);
            
        } catch (error) {
            setFotoAlumno(studentImage);
        }
    }

    async function agregarAlumno(alumno) {
        setAlumnosSeleccionados((prevAlumnos) => [...prevAlumnos, alumno]);
        setAlumnos((prevAlumnos) => prevAlumnos.filter((a) => a.MATRICULA !== alumno.MATRICULA));
        setShowSearch(false);
    }

    async function eliminarAlumno(alumno) {
        setAlumnos((prevAlumnos) => [...prevAlumnos, alumno]);
        setAlumnosSeleccionados((prevAlumnos) => prevAlumnos.filter((a) => a.MATRICULA !== alumno.MATRICULA));
    }

    const enviarMensaje = async () => {
        try {
            await api.postMessagePrefectos({mensaje, alumnosSeleccionados});
            setShowMessage(false);
            swal("¡Éxito!", "Los mensajes se enviaron correctamente.", "success");
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }

    }

    return (
        <>
        <div className= "seccion-materias hover-seccion fade-in">
            <div className= "seccion-centro">
                <div className='container-filtros'>
                    <div className='container-filtros-tabla'>
                        <div className='filtros-input'>
                            <label>Nivel</label>
                            <select name="Nivel" onChange={e => (setNivel(e.target.value))}>
                                <option value="1" defaultChecked>PREESCOLAR</option>
                                <option value="2">PRIMARIA</option>
                                <option value="3">SECUNDARIA</option>
                                <option value="4">PREPARATORIA</option>
                            </select>
                        </div>
                        <div className='filtros-input'>
                            <label>Grado</label>
                            <select name="Grado" onChange={e => (setGrado(e.target.value))}>
                                <option value="1" defaultChecked>PRIMERO</option>
                                <option value="2">SEGUNDO</option>
                                <option value="3">TERCERO</option>
                                {nivel === "2" ?
                                    <>
                                        <option value="4">CUARTO</option>
                                        <option value="5">QUINTO</option>
                                        <option value="6">SEXTO</option>
                                    </>
                                : ''}
                            </select>
                        </div>
                        <div className='filtros-input'>
                            <label>Grupo</label>
                            <input type="number" onChange={ e => (setGrupo(e.target.value))}></input>
                        </div>
                        <div className='asistencia-buscar'>
                            <label htmlFor='student-name'>Nombre del Alumno:</label>
                            <input type='text' name='student-name' value={alumno} onChange={e => {setAlumno(e.target.value)}}
                                style={{fontSize: '20px', height: '20px'}}></input>
                        </div>
                    </div>
                    <div className='buscar-envio-mensaje'>
                        <button onClick={buscarAlumnos}>BUSCAR</button>
                        <button onClick={buscar1Alumno} className='button-buscar-alumno'>BUSCAR ALUMNO</button>
                    </div>
                    <div className='button-enviar-mensaje'>
                        <button onClick={e => setShowMessage(true)} style={alumnosSeleccionados.length > 0 ? {} : buttonDisable}>ENVIAR MENSAJE</button>
                    </div>
                </div>
                <div className= "seccion-tabla-asistencias">
                    <div className= "hover-elemento">
                        {/* TABLA */}
                        <div className= "contenedor-tabla-mensajes">
                            <table className= "tabla-mensajes lista-mensajes">
                                <thead>
                                    <tr>
                                        <th><label>MATRICULA</label></th>
                                        <th><label>ALUMNO</label></th>
                                    </tr>
                                </thead>
                                <tbody className='select-pointer'>
                                    { alumnos && alumnos.map( (alumno, i) => { 
                                        return (
                                        <tr key={ i } onClick={e => agregarAlumno(alumno)}>
                                            <td>{ alumno.MATRICULA }</td>
                                            <td>{ alumno.NOMBRE }</td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            <table className= "tabla-mensajes alumnos-seleccionados">
                                <thead>
                                    <tr>
                                        <th><label>MATRICULA</label></th>
                                        <th><label>ALUMNO</label></th>
                                        <th><label>INFO</label></th>
                                        <th><label>ELIMINAR</label></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { alumnosSeleccionados && alumnosSeleccionados.map( (alumno, i) => { 
                                        return (
                                        <tr key={ i }>
                                            <td>{ alumno.MATRICULA }</td>
                                            <td>{ alumno.NOMBRE }</td>
                                            <td><label className='select-pointer-Info' onClick={e => verInfoAlumno(alumno)}><FontAwesomeIcon icon={faClipboard} /></label></td>
                                            <td><label className='select-pointer-X' onClick={e => eliminarAlumno(alumno)} ><FontAwesomeIcon icon={faTrash} /></label></td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        { showSearch ? <>
            <div className="overlay"></div>
            <div className='container-buscar-alumno'>
                <div className='title-buscar-alumno'>
                    <h3>SELECCIONA AL ALUMNO</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowSearch(false)}> X </label>
                </div>
                <div className='container-table-buscar-alumno'>
                    <table className='table-buscar-alumno'>
                        <thead>
                            <tr>
                                <th><label>MATRICULA</label></th>
                                <th><label>ALUMNO</label></th>
                                <th><label>TURNO</label></th>
                                <th><label>GRADO</label></th>
                                <th><label>GRUPO</label></th>
                            </tr>
                        </thead>
                        <tbody>
                            { listaAlumnos && listaAlumnos.map( (alumno, i) => { 
                                return (
                                <tr key={ i } onClick={e => agregarAlumno(alumno)}>
                                    <td>{ alumno.MATRICULA }</td>
                                    <td>{ alumno.ALUMNO }</td>
                                    <td>{ alumno.NIVEL }</td>
                                    <td>{ alumno.ID_GRADO }</td>
                                    <td>{ alumno.GRUPO }</td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </> : ''}
        { showMessage ? <>
            <div className='overlay'></div>
            <div className='container-message'>
                <div className='titulo-message'>
                    <h3>ESCRIBE EL MENSAJE A ENVIAR</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowMessage(false)}> X </label>
                </div>
                <div className='message'>
                    <textarea value={mensaje} onChange={e => setMensaje(e.target.value)}></textarea >
                </div>
                <div className='button-enviar-mensaje'>
                    <button onClick={enviarMensaje}>ENVIAR</button>
                </div>
            </div>
        </> : ''}
        { showInfo ? <>
            <div className='overlay'></div>
            <div className='container-info-mensaje'>
                <div className='titulo-message'>
                    <h3>INFORMACIÓN DEL ALUMNO</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowInfo(false)}> X </label>
                </div>
                <div className='container-info-alumno'>
                    <img src={fotoAlumno} alt="foto-alumno" />
                    <div className='data-info-alumno'>
                        <label>Matricula: <p>{ infoAlumno.MATRICULA }</p></label>
                        <label>Nombre: <p>{ infoAlumno.NOMBRE }</p></label>
                        <label>Turno, Grado y Grupo: <p>{ infoAlumno.NIVEL + " " + infoAlumno.ID_GRADO + " " + infoAlumno.GRUPO}</p></label>
                    </div>
                </div>
            </div>
        </> : ''}
        </>
    );
};

export default EnvioMensajes;